export const graspAvailableColors = [null, '#2875b2', '#f5842a', '#48a447'];
